import React from 'react';
import { useState } from 'react';

export const SeoContext = React.createContext();

export const SeoProvider = (props) => {
	const [ data, setData ] = useState(props.seo);
	return <SeoContext.Provider value={{ data, setData }}>{props.children}</SeoContext.Provider>;
};
